<template>
  <b-button size="sm" variant="primary" @click="$emit('click')" aria-label="reload">
    <i class="fa fa-refresh"></i>
  </b-button>
</template>

<script>
export default {
  name: 'VsmReloadButton',
}
</script>
